"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconTumblr = Experimental__IconTumblr;
exports.IconTumblr = IconTumblr;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconTumblr/index.tsx)
 */
function IconTumblr(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M9.008 10.587V6.921h2.38V4.794H9.017v-3.16H7.15a.083.083 0 0 0-.06.029.119.119 0 0 0-.035.067 4.734 4.734 0 0 1-.112.663c-.053.22-.14.469-.261.746-.122.278-.27.532-.445.762-.175.23-.407.453-.698.67a3.759 3.759 0 0 1-.992.524v1.826h1.476v3.865c0 .296.036.592.107.889.071.296.197.596.377.9.18.305.403.57.67.798.267.227.615.411 1.044.552.429.14.91.205 1.445.194a4.273 4.273 0 0 0 1.357-.242c.45-.156.735-.319.857-.488l-.62-1.786c-.285.133-.626.204-1.023.214a1.505 1.505 0 0 1-.619-.099.803.803 0 0 1-.38-.305 1.386 1.386 0 0 1-.18-.397 1.723 1.723 0 0 1-.051-.429h.001z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M13.512 15.88v-5.499h3.57v-3.19h-3.557V2.45h-2.8a.124.124 0 0 0-.09.043.179.179 0 0 0-.053.1 7.098 7.098 0 0 1-.168.995c-.079.33-.209.703-.391 1.12a5.606 5.606 0 0 1-.668 1.142c-.261.345-.61.68-1.046 1.005a5.638 5.638 0 0 1-1.488.786v2.74h2.213v5.797c0 .444.054.888.161 1.333.107.444.296.894.566 1.35.27.457.605.856 1.005 1.197.4.341.922.617 1.566.828.643.21 1.365.307 2.167.291a6.41 6.41 0 0 0 2.036-.363c.674-.234 1.102-.478 1.285-.732l-.93-2.679c-.428.2-.94.306-1.535.321-.364.008-.674-.041-.928-.148a1.205 1.205 0 0 1-.57-.458 2.081 2.081 0 0 1-.27-.595 2.586 2.586 0 0 1-.076-.644h.001z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconTumblr is deprecated and will be archived soon. Use IconTumblr instead.
 */
function Experimental__IconTumblr(props) {
  return /*#__PURE__*/_react["default"].createElement(IconTumblr, props);
}